import React, { useCallback, useState, useEffect, FormEvent } from 'react';
import DeviceSelectionScreen from './DeviceSelectionScreen/DeviceSelectionScreen';
import IntroContainer from '../IntroContainer/IntroContainer';
import MediaErrorSnackbar from './MediaErrorSnackbar/MediaErrorSnackbar';
import RoomNameScreen from './RoomNameScreen/RoomNameScreen';
import { useAppState } from '../../state';
import { useParams, useLocation } from 'react-router-dom';
import GuestJoinScreen from '../GuestJoinScreen/GuestJoinScreen';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import Cookies from 'universal-cookie';
import { LocalVideoTrack } from 'twilio-video';
import useMediaStreamTrack from '../../hooks/useMediaStreamTrack/useMediaStreamTrack';
import { DEFAULT_VIDEO_CONSTRAINTS } from '../../constants';
export enum Steps {
  roomNameStep,
  deviceSelectionStep,
}
var response = {
  code: 100,
  data: {
    firstName: '',
    lastName: '',
    roomName: '',
    type: 'host',
    actionText: '',
    enableActionButton: '',
  },
};
export default function PreJoinScreens() {
  const { user } = useAppState();
  const { getAudioAndVideoTracks } = useVideoContext();
  const { URLRoomName: urlRoomName } = useParams<{ URLRoomName: string }>();
  const location = useLocation();

  const isGuestRoute = location.pathname.startsWith('/guest');

  const [step, setStep] = useState(Steps.roomNameStep);

  const [name, setName] = useState<string>(user?.displayName || '');
  const [roomName, setRoomName] = useState<string>('');

  const [mediaError, setMediaError] = useState<Error>();
  const [avFilter, setAvFilter] = useState<string | null | undefined>();

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);

    // console.log(process.env.REACT_APP_ENDPOINT)

    const uid = queryParams.get('uid');

    const fullAPI = `${process.env.REACT_APP_ENDPOINT}/twillio/joiningclass?` + 'uuid=' + uid;

    fetch(fullAPI)
      .then(res => res.json())
      .then(booksList => {
        // temp fix to solve inclinic issue need to remove
        // console.log('callingType', booksList.data.callingType);
        // if (booksList.data.callingType == null) {
        //   booksList.data.callingType = 'video';
        // }
        localStorage.setItem('avFilter', booksList.data.callingType || 'video');
        setAvFilter(booksList.data.callingType);
        console.log(booksList.data.callingType);
        response.data = booksList;

        response.data.firstName = booksList.data.firstName;
        response.data.lastName = booksList.data.lastName;
        response.data.roomName = booksList.data.roomName;
        response.data.actionText = booksList.data.actionText;
        response.data.enableActionButton = booksList.data.enableActionButton;
        const cookies = new Cookies();

        cookies.set('hostType', booksList.data.type, { path: '/' });
        cookies.set('callingType', booksList.data.callingType, { path: '/' });
        cookies.set('uid', uid, { path: '/' });
        localStorage.setItem('disconnectbutton', booksList.data.disconnectbutton);
        localStorage.setItem('logo', booksList.data.logo || '');
        localStorage.setItem('adhd', booksList?.data?.adhd || '');
        localStorage.setItem('reconnectingState', booksList.data.reconnectingState);
        localStorage.setItem('doctorreconnectingState', booksList.data.doctorreconnectingState);
        localStorage.setItem('selfjoinmessage', booksList.data.selfjoinmessage || '');
        localStorage.setItem('disconnectbuttonconfirmation', booksList.data.disconnectbuttonconfirmation || '');
        localStorage.setItem('consent', booksList.data.consent || '');

        setRoomName(response.data.roomName);

        setStep(Steps.deviceSelectionStep);
      })
      .catch(console.log);
  }, [user, urlRoomName]);

  useEffect(() => {
    if (step === Steps.deviceSelectionStep && !mediaError) {
      getAudioAndVideoTracks().catch(error => {
        console.log('Error acquiring local media:');
        console.dir(error);
        setMediaError(error);
      });
    }
  }, [getAudioAndVideoTracks, step, mediaError]);

  if (isGuestRoute) {
    return <GuestJoinScreen />;
  }

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    // If this app is deployed as a twilio function, don't change the URL because routing isn't supported.
    if (!window.location.origin.includes('twil.io')) {
      window.history.replaceState(null, '', window.encodeURI(`/room/${roomName}${window.location.search || ''}`));
    }
    setStep(Steps.deviceSelectionStep);
  };

  return (
    <IntroContainer>
      <DeviceSelectionScreen
        av={avFilter}
        name={response.data.firstName}
        roomName={response.data.roomName}
        setStep={setStep}
        actionText={response.data.actionText}
        enableActionButton={response.data.enableActionButton}
      />
    </IntroContainer>
  );
}
